export default __webpack_public_path__ + "static/media/quiz.0ab8db9b.png";